<template>
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
  >
    <path d="M9 5.50004C9.27614 5.50004 9.5 5.7239 9.5 6.00004V10C9.5 10.2762 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2762 8.5 10V6.00004C8.5 5.7239 8.72386 5.50004 9 5.50004ZM9 13C9.41421 13 9.75 12.6643 9.75 12.25C9.75 11.8358 9.41421 11.5 9 11.5C8.58579 11.5 8.25 11.8358 8.25 12.25C8.25 12.6643 8.58579 13 9 13ZM7.68569 1.3522C8.25558 0.316035 9.74445 0.316031 10.3143 1.35219L16.8731 13.2772C17.4229 14.2768 16.6996 15.5 15.5587 15.5H2.44129C1.30038 15.5 0.577137 14.2768 1.12696 13.2772L7.68569 1.3522ZM9.43812 1.83411C9.24816 1.48873 8.75187 1.48873 8.56191 1.83411L2.00318 13.7591C1.8199 14.0923 2.06098 14.5 2.44129 14.5H15.5587C15.939 14.5 16.1801 14.0923 15.9969 13.7591L9.43812 1.83411Z" />
  </svg>
</template>
